import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: 'page-xp-gym-home',
  templateUrl: 'xp-gym-home.html'
})
export class XpGymHomePage {

  steps = [
    {
      number: 1,
      icon: 'qr-scanner',
      title: 'Escaneá',
      description: 'Apuntá la cámara al QR de la máquina. La pantalla es solo el lente, nada más.'
    },
    {
      number: 2,
      icon: 'options',
      title: 'Ajustá',
      description: 'Ya sabe qué máquina es. Elegí su propia medida: placas, kilos o nivel de asistencia.'
    },
    {
      number: 3,
      icon: 'stopwatch',
      title: 'Registrá',
      description: 'Anotá las repeticiones o usá el cronómetro. Siempre ves en qué serie vas.'
    },
    {
      number: 4,
      icon: 'list-box',
      title: 'Revisá',
      description: 'Mirá todas las máquinas de hoy y compartilas por mail o mensaje.'
    }
  ];

  constructor(
    public navCtrl: NavController,
    public translate: TranslateService
  ){}

  ionViewDidLoad() {
    console.log('ionViewDidLoad XpGymHomePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-gym-home/xp-gym-home.ts